module.exports = __webpack_public_path__ + "img/back_max.840d92e0.png";